export const onInputChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (newValue: number) => void
) => {
  const newValue: number = Number(e.target.value);
  const isValueCorrect =
    !e.target.value || (!Number.isNaN(newValue) && newValue >= 0);
  if (onChange && isValueCorrect) {
    onChange((e.target.value && newValue) ?? null);
  }
};

export default onInputChange;
